// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---node-modules-gatsby-theme-dox-src-templates-doc-js": () => import("./../../../node_modules/gatsby-theme-dox/src/templates/doc.js" /* webpackChunkName: "component---node-modules-gatsby-theme-dox-src-templates-doc-js" */)
}

